<template>
  <nav ref="nav" class="app-navbar bg-light position-absolute d-flex justify-content-between justify-content-md-around align-items-center flex-wrap">
    <div class="border-right w-md-100">
      <router-link class="p-1 " to="/"> <img src="/images/logo.png" /> </router-link>
    </div>
    <ul class="d-none d-md-block">
      <li>
        <router-link class="h5" to="/"> HOME </router-link>
      </li>
      <li>
        <router-link class="h5" to="/products"> SHOP </router-link>
      </li>
      
      <li v-if="!isLoggedIn">
        <router-link class="h5" to="/login"> LOGIN </router-link>
      </li>
      <li v-if="!isLoggedIn">
        <router-link class="h5" to="/signup"> SIGNUP </router-link>
      </li>
      <li v-if="isLoggedIn">
        <router-link class="h5" to="/wishlist"> WISHLIST </router-link>
      </li>
      <li v-if="isLoggedIn">
        <router-link class="h5" to="/checkout"> CHECKOUT </router-link>
      </li>
      <li v-if="isLoggedIn">
        <router-link class="h5" to="/account"> ACCOUNT </router-link>
      </li>
    </ul>
    <!-- mobile button -->
    <button class="nav-item d-block d-md-none btn" role="button" type="button" @click="show()">
      <i class="fa fa-bars text-primary h4" aria-hidden="true"></i>
    </button>
    <!-- *** -->
    <div v-if="isLoggedIn" class="d-inline-flex justify-content-between align-items-center">
      <span v-if="isLoggedIn" class="nav-item dropdown mr-3">
        <button role="button" type="button" class="btn position-relative" @click="checkoutCartOpened = !checkoutCartOpened">
          <span class="text-center cart-items-num position-absolute bg-light rounded-circle p-1">{{cartItems.length}}</span>
          <i class="fa fa-shopping-basket text-danger h4" aria-hidden="true"></i>
        </button>
        <div v-if="isLoggedIn && checkoutCartOpened" class="position-absolute shadow bg-light py-2 px-1 dropdown-menu-right checkout-cart" aria-labelledby="navbarDropdown">
          <div class="d-flex justify-content-between">
            <span class="p-1 h6">{{cartItems.length}} items</span>
            <span class="p1 h6">
              <strong>${{ cartItems.length ? cartItems.reduce((a,b)=> ({price: +a.price + +b.price})).price : 0 }}
              </strong>
            </span>
          </div>
          <ul class="checkout-list" v-if="cartItems.length">
            <li v-for="item in cartItems" :key="item.id" class="d-flex align-items-center justify-content-between p-1 my-2 border-bottom">
              <img :src="item.photo" width="60" height="60" alt="">
              <div class="product-info text-left">
                <span class="product-name d-block">{{item.Product_name}} </span>
                <span class="product-price d-block text-danger">{{item.price}}</span>
              </div>
              <span class="remove-product text-danger btn" @click="deleteItem(item.id)">
                <i class="fa fa-trash text-danger"></i>
              </span>
            </li>
<!--
            <li class="d-flex align-items-center justify-content-between p-1 my-2 border-bottom">
              <img src="/images/products/product_2.jpg" width="60" height="60" alt="">
              <div class="product-info text-left">
                <span class="product-name d-block">Lorem ipsum </span>
                <span class="product-price d-block text-danger">12.90</span>
              </div>
              <span class="remove-product text-danger btn">X</span>
            </li>

            <li class="d-flex align-items-center justify-content-between p-1 my-2 border-bottom">
              <img src="/images/products/product_3.jpg" width="60" height="60" alt="">
              <div class="product-info text-left">
                <span class="product-name d-block">Lorem ipsum </span>
                <span class="product-price d-block text-danger">45.68</span>
              </div>
              <span class="remove-product text-danger btn">X</span>
            </li> -->

          </ul>
          <router-link to="/checkout" class="main-btn d-block w-75 mx-auto mt-3 text-center" v-if="cartItems.length">
            <span class="text">CHECKOUT</span>
            <span class="semicircle"></span>
          </router-link>
          <p class="p-2 text-center" v-if="!cartItems.length">there are no items</p>
        </div>
      </span>
      <span v-if="isLoggedIn" class="nav-item dropdown mr-3 d-none d-md-block">
        <button role="button" type="button" class="btn" data-toggle="dropdown">
          <i class="fa fa-bars text-primary h4" aria-hidden="true"></i>
        </button>
        <div v-if="isLoggedIn" class="dropdown-menu dropdown-menu-right user-pages" aria-labelledby="navbarDropdown">
          <router-link class="dropdown-item border-bottom py-2" to="/account">Account</router-link>
          <router-link class="dropdown-item border-bottom py-2" to="/wishlist">wish list</router-link>
          <router-link class="dropdown-item border-bottom py-2" to="/checkout">checkout</router-link>
          <span @click="logout" class="btn dropdown-item py-2" href="#">logout</span>
        </div>
      </span>
    </div>
      <!-- <li>
        <router-link to="/login"> LOGIN </router-link>
      </li>
      <li>
        <router-link to="/signup"> SIGNUP </router-link>
      </li> -->
  </nav>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  name: 'NavBar',
  data(){
    return {
      isLoggedIn: false,
      checkoutCartOpened: false
    }
  },
  computed:{
    cartItems(){
      return this.$store.state.shopCart
    }
  },
  mounted(){
    window.localStorage.getItem('care_user_auth_token') ? this.isLoggedIn = true : this.isLoggedIn = false
    window.addEventListener('scroll', (e)=>{
      if(this.$refs.nav){
        if(window.scrollY > 300 && innerWidth >  767){
          this.$refs.nav.classList.add('position-top')
          this.$refs.nav.classList.remove('position-absolute')
        } else{
          this.$refs.nav.classList.remove('position-top')
          this.$refs.nav.classList.add('position-absolute')
        }
      }
    })
  },
  methods:{
    ...mapMutations(["removeFromCart"]),
    show(){
      this.$emit('showAside')
    },
    logout(){
      localStorage.removeItem('care_user_auth_token');
      localStorage.removeItem('care_user_id');
      localStorage.removeItem('care_user_name');
      this.$router.history.push('/login');
    },
    deleteItem(id){
      console.log(id);
      this.removeFromCart(id)
    }
  }
}
</script>

<style scoped>
.app-navbar {
  z-index: 999999;
  width: calc(100% - 20px);
  max-width: 1100px;
  top: 20px;
  left: 50%;
  transform: translate(-50%, 0);
  margin: .25rem auto;
}
.app-navbar ul {
  list-style-type: none;
  padding: 0;
  margin: 0
}
.app-navbar ul li {
  display: inline-block;
}
.app-navbar ul li a {
  color: #2a81ea !important;
  padding: 1.25rem .25rem;
  margin: .5rem;
  /* font-size: 20px; */
}
.app-navbar ul li a:hover {
  color: #444 !important;
}
.app-navbar ul li a:active {
  color: #444 !important;
  background: transparent
}
.position-top{
  position: fixed;
  top:0;
  max-width:100%;
  margin: 0;
  border-top: 8px solid #2a81ea;
  box-shadow:0 2px 2px rgb(0, 0, 0 , .1)
}
.user-pages{
  border-top: 4px solid #0080ff;
  width: 220px;
}
.checkout-cart{
  width: 310px;
  border-top: 4px solid #0080ff;
  top: 55px
}
.checkout-list{
  height: 230px;
  overflow-y: auto
}
.app-navbar ul li a.router-link-exact-active{
  color: #000 !important
}
.cart-items-num{
  top: -25px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 30px;
  height: 30px;
  font-weight: 900
}
@media(max-width: 860px){
  .w-md-100{
    width: 100%;
    text-align: center;
    padding: 1rem
  }
}
</style>
